'use client';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { useEffect } from 'react';
import { login, logout, updateUser } from './slices/UserSlice';
import { STORAGE } from '../_config';

function TokenValidator() {
  useEffect(() => {
    try {
      const persistedData = localStorage.getItem(STORAGE);
      if (!persistedData) {
        store.dispatch(logout());
        return;
      }

      const userData = JSON.parse(persistedData);
      if (!userData || !userData.accessToken) {
        store.dispatch(logout());
      } else {
        // Validate token expiration
        if (userData.expires_at && new Date(userData.expires_at) < new Date()) {
          // Token has expired, should implement refresh token logic here
          // For now, just log the user out
          store.dispatch(logout());
        } else {
          // If token is still valid, ensure the Redux store is synced with localStorage
          store.dispatch(
            login({
              token: userData.accessToken,
              email: userData.user?.email || '',
              expires_at: userData.expires_at,
            })
          );
          
          if (userData.user) {
            store.dispatch(updateUser({ user: userData.user }));
          }
        }
      }
    } catch (error) {
      console.error("Error validating token:", error);
      store.dispatch(logout());
    }
  }, []);

  return null;
}

export function ReduxProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <TokenValidator />
        {children}
      </PersistGate>
    </Provider>
  );
}
